import * as yup from 'yup';

export const cancelReasonField = yup.string().min(1).max(50).nullable();

export const updateOrderSchema = yup.object().shape({
  confirm: cancelReasonField,
  reject: cancelReasonField,
});
export const cancelOrderSchema = (reasonIsRequired: boolean) =>
  yup.object().shape({
    reason: reasonIsRequired ? cancelReasonField.required() : cancelReasonField,
  });
